
import { axiosInstance } from '../utils';
import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'


const GoldPrices = () => {
    const [goldPrices, setGoldPrices] = useState(null);

    const token = localStorage.getItem("token");

   const getGoldPrices =  () => {
      axiosInstance.post("/api/get-gold-prices-for-admin", "", {
        headers: {
            Authorization: `Bearer ${token}`
        }
     })
     .then(res =>  {
         setGoldPrices(res.data) } 
     )
     .catch(err => { 
        toast.error(err.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        });
    }
     )
   }

   useEffect(() => {
       getGoldPrices();
    const goldPricerTimer = setInterval(() => {
       getGoldPrices();
    }, 1000);
    return () => clearInterval(goldPricerTimer);
   }, []);
  return (
    <div className='flex items-center gap-10 pb-24'>
            <div className='flex flex-col space-2'>
                <h1 className='heading-one text-primary-green'>RM {goldPrices?.buyPrice}</h1>
                <p className='text-regular !text-xs'>Buy Price</p>
            </div>
            <div className='flex flex-col space-2'>
                <h1 className='heading-one text-primary-red-500'>RM {goldPrices?.sellPrice}</h1>
                <p className='text-regular !text-xs'>Sell Price</p>
            </div>
            <ToastContainer />
        </div>
  )
}

export default GoldPrices